import axios from "axios";
import store from "../redux/store/store";
import { logout } from "../redux/action/auth_action";

// const baseURL = "https://belabs.medicitylab.co/api/v1";
// const baseURL = "https://lisbe.aarggvtech.com/api/v1";
// const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL
// const baseURL = "https://belabs.labhpathlabs.com/api/v1/LIS";
const baseURL = "https://labs.labhpathlabs.com/api/v1";
const axiosInstance = axios.create({
  baseURL,
});

const getCompanyLocalStorageId = () => {
  const companyId = Number(localStorage.getItem("company_id"));
  return Number.isNaN(companyId) || !companyId ? null : companyId;
};

const shouldAttachCompanyId = (method = "") =>
  ["post", "put", "patch","delete"].includes(method.toLowerCase());

const attachCompanyIdToPayload = (data, companyId) => {
  if (!companyId) {
    return data;
  }

  if (!data) {
    return { company_id: companyId };
  }

  if (typeof FormData !== "undefined" && data instanceof FormData) {
    if (!data.has("company_id")) {
      data.append("company_id", companyId);
    }
    return data;
  }

  if (
    typeof URLSearchParams !== "undefined" &&
    data instanceof URLSearchParams
  ) {
    if (!data.has("company_id")) {
      data.append("company_id", companyId);
    }
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) =>
      item && typeof item === "object" && !Array.isArray(item)
        ? {
            company_id: companyId,
            ...item,
          }
        : item,
    );
  }

  if (typeof data === "object") {
    return {
      company_id: companyId,
      ...data,
    };
  }

  return data;
};

axiosInstance.interceptors.request.use((config) => {
  const companyId = getCompanyLocalStorageId();

  if (
    !companyId ||
    !shouldAttachCompanyId(config.method) ||
    config.url?.includes("/auth/login")
  ) {
    return config;
  }

  // if (["get", "delete"].includes(config.method?.toLowerCase())) {
  //   config.params = {
  //     company_id: companyId,
  //     ...(config.params || {}),
  //   };
  //   return config;
  // }

  config.data = attachCompanyIdToPayload(config.data, companyId);
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401 || status === 403) {
        setTimeout(() => {
          store.dispatch(logout());
        }, 2000);
      }
    }

    return Promise.reject(error);
  },
);

if (localStorage.getItem("zone_id")) {
  axiosInstance.defaults.headers.common["x-custom-zone-id"] =
    localStorage.getItem("zone_id");
}
if (localStorage.getItem("franchise_id")) {
  axiosInstance.defaults.headers.common["x-custom-franchise-id"] =
    localStorage.getItem("franchise_id");
}
if (localStorage.getItem("is_super_franchise")) {
  axiosInstance.defaults.headers.common["x-custom-is-super-franchise"] =
    localStorage.getItem("is_super_franchise");
}
if (localStorage.getItem("is_franchise_employee")) {
  axiosInstance.defaults.headers.common["x-custom-is-franchise-employee"] =
    localStorage.getItem("is_franchise_employee");
}

export default axiosInstance;
